var $fb78e0f6ab6349ed$exports = {};
$fb78e0f6ab6349ed$exports = {
  "decrease": function decrease(args) {
    return "\u062E\u0641\u0636 ".concat(args.fieldLabel);
  },
  "increase": function increase(args) {
    return "\u0632\u064A\u0627\u062F\u0629 ".concat(args.fieldLabel);
  },
  "numberField": "\u062D\u0642\u0644 \u0631\u0642\u0645\u064A"
};
export { $fb78e0f6ab6349ed$exports as default };